<template>
  <div :class="name">
    <b-field :label="label">
      <b-input @input="set" :value="currentValue" :disabled="disabled" placeholder="Valor"></b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    name: {
      type: String,
      default: () => ''
    },
    currentValue: {
      type: String,
      default: () => ''
    },
    label: {
      type: String,
      default: () => null
    },
    handler: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    groupIndex: {
      type: Number,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    }
  },
  methods: {
    set(value) {
      const { groupIndex, index, handler, name } = this
      this.$emit('set', { name, value, groupIndex, index, handler })
    }
  }
}
</script>

<style lang="scss">

</style>
